import {
  TextField as MUITextField,
  // TextFieldProps,
  styled,
} from "@mui/material";
import "./text-field.scss";
import Typography from "../typography/typography";
import { memo } from "react";

const StyledTextField = styled(MUITextField)(({ theme: { palette } }) => ({
  "& .MuiOutlinedInput-root": {
    padding: "0",
    color: palette.theme?.secondary[800],
    "& fieldset": {
      borderColor: palette.theme?.secondary[400],
    },
    "&:hover fieldset": {
      borderColor: palette.theme?.secondary[500],
    },
    "&.Mui-focused fieldset": {
      borderWidth: "0.0625rem",
      borderStyle: "solid",
      borderColor: palette.theme?.primary[700],
    },
    "&.Mui-error fieldset": {
      borderColor: palette.theme?.error[600],
    },
    "&.Mui-error .MuiInputBase-input::placeholder": {
      color: palette.theme?.error[600],
    },
    "&.Mui-disabled": {
      background: palette.theme?.secondary[200],
      color: palette.theme?.secondary[800],
    },
    "& .MuiInputBase-input::placeholder": {
      color: palette.theme?.secondary[800],
      opacity: 1,
    },
  },
  "& .MuiFormHelperText-root": {
    marginLeft: 0,
    color: palette.theme?.secondary[800],
    "&.Mui-error": {
      color: palette.theme?.error[600],
    },
  },
  "& .MuiIconButton-root": {
    marginRight: 0,
  },
}));

const TextField = memo((props: any) => {
  const {
    required,
    placeholder,
    label,
    error = false,
    dataPosition,
    dataName,
    hidden,
    ...rest
  } = props;
  return (
    <>
      {label && !hidden && (
        <Typography
          type="s5"
          weight={"medium"}
          mb={0.5}
          color={error ? "theme.error.600" : "theme.secondary.800"}
          data-position={dataPosition}
          data-name={dataName}
        >
          {label} {required && <span className="requiredStar">*</span>}
        </Typography>
      )}
      <StyledTextField
        error={error}
        placeholder={placeholder}
        className="textfield"
        hidden={hidden}
        {...rest}
      />
    </>
  );
});

export { TextField };
export default TextField;
